import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpHelperService } from "src/app/shared/services/http-helper.service";

@Injectable()
export class ELibraryService {
  constructor(private readonly httpHelperService: HttpHelperService) {}

  public getELibraryStructuredFolder(body): Observable<any> {
    return this.httpHelperService.post(
      `/cms/folder/structured-contents/folders-contents`,
      body,
    );
  }

  public getELibraryContent(body): Observable<any> {
    return this.httpHelperService.post(
      `/cms/folder/structured-contents/contents`,
      body,
    );
  }

  public searchELibraryContent(body): Observable<any> {
    return this.httpHelperService.post(
      `/cms/site/structured-contents/contents`,
      body,
    );
  }

  public getRecentUpload(body): Observable<any> {
    return this.httpHelperService.post(
      `/cms/site/structured-contents/recent-uploads`,
      body,
    );
  }

  public getSingleProductDetails(body): Observable<any> {
    return this.getELibraryStructuredFolder(body);
  }

  public getFilterLOV(body): Observable<any> {
    body.dashboardFlag = true;
    return this.httpHelperService.post(`/cms/filter/lov`, body);
  }
}
